import axios from 'axios';
import {env_api} from "./env";

// 使用环境变量配置 API 基础 URL
const baseURL = env_api(process.env.REACT_APP_ENV) || 'https://rd.aurastone.tech'
console.log('当前环境:', process.env.REACT_APP_ENV, 'API 地址:', baseURL)

const api_back = axios.create({
    baseURL
})

export default api_back

